
<template slot="Content">
  <router-view></router-view>
</template>
<script>
    import router from '@/router/index.js'
    export default {
        name: 'MasterDuplicates',
        router,
        computed:{
          route(){ 
            console.log(this.$route);
            return this.$route.params
            ;}
        }
    };
</script>